<template>
  <v-dialog v-model="display" persistent max-width="350">
    <v-card class="mx-auto secondary">
      <CardHeader :title="title" icon="mdi-close" @iconClicked="reject" />
      <v-card-subtitle v-if="description" class="pt-5 pb-2 px-2">{{
        description
      }}</v-card-subtitle>
      <v-file-input
        v-model="file"
        truncate-length="25"
        prepend-icon=""
        prepend-inner-icon="$file"
        :accept="filetype"
        clearable
        outlined
        dense
        color="primary"
        background-color="white"
        class="mx-2"
      ></v-file-input>
      <v-card-actions>
        <v-spacer />
        <v-btn text class="text-left" @click="reject()">
          Fortryd
        </v-btn>
        <v-btn :disabled="!file" class="text-right" @click="accept()">
          Vælg
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CardHeader from "@/components/templates/CardHeader.vue";

export default {
  components: {
    CardHeader
  },
  props: {
    display: { type: Boolean, required: true },
    title: { type: String, required: true },
    description: String,
    filetype: String
  },
  data() {
    return { file: null };
  },
  methods: {
    reject() {
      this.file = null;
      this.$emit("rejected");
    },
    accept() {
      const selectedFile = this.file;
      this.file = null;
      this.$emit("accepted", selectedFile);
    }
  }
};
</script>
